import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./CardHeader.styled";
export const CardHeader = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { align = "flex-start", children, endItemsFixed, endItemsFixedWidth, endItems, subtitle, title, ...otherProps } = props;
    const isEndItemFixed = endItemsFixed !== undefined;
    const headerPaddingEnd = endItemsFixedWidth ? endItemsFixedWidth : endItemsFixed && endItems ? "36px" : "16px";
    const getTitle = title && _jsx(Styled.CardHeaderTitle, { children: title });
    const getSubtitle = subtitle && _jsx(Styled.CardHeaderSubtitle, { children: subtitle });
    const getEndItems = endItems && _jsx(Styled.CardHeaderEnd, { children: endItems });
    return (_jsxs(Styled.CardHeader, { "data-testid": "CardHeader", ref: ref, align: align, headerPaddingEnd: headerPaddingEnd, ...otherProps, children: [title || subtitle ? (endItems ? (_jsxs(Styled.CardHeaderWrapper, { children: [_jsxs(Styled.CardHeaderTitleWrapper, { isEndItemFixed: isEndItemFixed, children: [getTitle, getSubtitle] }), getEndItems] })) : (_jsxs(Styled.CardHeaderTitleWrapper, { isEndItemFixed: Boolean(isEndItemFixed), children: [getTitle, getSubtitle] }))) : (getEndItems), endItemsFixed && _jsx(Styled.CardHeaderEndFixed, { children: endItemsFixed }), children] }));
});
CardHeader.defaultProps = {
    align: "flex-start"
};
CardHeader.displayName = "CardHeader";
